// extracted by mini-css-extract-plugin
export default {"ToursList":"ToursList_ToursList__LFBhq","header":"ToursList_header__WuGYx","header-border":"ToursList_header-border__xEEGF","loadTours":"ToursList_loadTours__U8nSW"};